import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SearchObjectService } from '../../shared/services/search-object.service';
import { SERVICE_URL, SERVICE_API_VERSION } from '../../tokens';
import { SortTypes } from 'src/app/shared/models/FIlterTerms';

@Injectable({
  providedIn: 'root',
})
export class SearchService {

    private providersUrl;
    private searchFiltersUrl;

    constructor(private http: HttpClient, private searchObjectService: SearchObjectService, @Inject(SERVICE_API_VERSION) private apiVersion: string, @Inject(SERVICE_URL) private serviceUrl: any) {
        this.providersUrl = `${this.serviceUrl}Providers`;
        this.searchFiltersUrl = `${this.serviceUrl}SearchFilters`;
    }

    getProviders(): Observable<any> {
        const headers = new HttpHeaders({ 'cache-response': 'true' });
        return this.http.get(this.providersUrl, { headers, params: this.getParamsObject() });
    }

    getSearchFilters(): Observable<any> {
        return this.http.get(this.searchFiltersUrl, {params: this.getSearchFiltersObject()});
    }

    getSearchFiltersObject(): HttpParams {
        const searchObject = this.searchObjectService.getSearchObject();
        const fromObject = {
            'networkId' : searchObject.networkId,
            'county' : searchObject.county,
            'stateCode' : searchObject.state,
            'subProductKey' : this.searchObjectService.getSubProductKey()
        };

        if (!searchObject.county) {
            fromObject['zipCode'] = searchObject.zipCode;
        }

        const params = new HttpParams({
            fromObject: this.removeEmpty(fromObject)
        });

        return params;
    }

    getParamsObject(): HttpParams {
        const searchObject = this.searchObjectService.getSearchObject();
        const apiVersion = this.apiVersion;
        let specialty = searchObject.specialty;
        if (specialty === "Urgent Care & Convenience Care Clinics") {
            specialty = "Urgent Care|Convenience Care Clinics";
        }
        const fromObject = {
            'api-version': apiVersion,
            'networkId' : searchObject.networkId,
            'providerName' : searchObject.providerName,
            'phoneNumber': searchObject.phoneNumber ? searchObject.phoneNumber.replace(/\D/g, '') : null,
            'specialty' : specialty,
            'providerType': searchObject.providerType,
            'radius' : !searchObject.isServiceAreaSearch ? searchObject.mileRadius : '',
            'latitude' : searchObject.lat,
            'longitude' : searchObject.long,
            'county' : searchObject.isServiceAreaSearch ? searchObject.county : '',
            'stateCode' : searchObject.isServiceAreaSearch ? searchObject.state : '',
            'acceptingNewPatientsIndicator' : searchObject.filters.acceptingNewPatients ? searchObject.filters.acceptingNewPatients : '',
            'eveningHoursIndicator' : searchObject.filters.eveningHours ? searchObject.filters.eveningHours : '',
            'weekendHoursIndicator' : searchObject.filters.weekendHours ? searchObject.filters.weekendHours : '',
            'handicapAccessIndicator' : searchObject.filters.handicapAccess ? searchObject.filters.handicapAccess : '',
            'teleHealthIndicator' : searchObject.filters.telehealth ? searchObject.filters.telehealth : '',
            'accreditedFacilityIndicator' : searchObject.filters.accreditedFacility ? searchObject.filters.accreditedFacility : '',
            'subProductKey' : this.searchObjectService.getSubProductKey(),
            'language' : searchObject.filters.language ? searchObject.filters.language : '',
            'gender' : searchObject.filters.gender ? searchObject.filters.gender : '',
            'hospitalPrivilege' : searchObject.filters.hospitalPrivilege ? searchObject.filters.hospitalPrivilege : '',
            'searchType' : this.searchObjectService.getSearchType(),
            'planYear' : searchObject.searchYear ? searchObject.searchYear : '',
            'sortType' : searchObject.providerName ? (searchObject.filters.sortType ? searchObject.filters.sortType : SortTypes.BestMatch) : SortTypes.Distance,
            'affirmingProviderForLGBTQIAPlusIndicator' : searchObject.filters.lgbtqia ? searchObject.filters.lgbtqia : ''
        };

        const params = new HttpParams({
            fromObject: this.removeEmpty(fromObject)
        });

        return params;

    }

    // TODO: make into pipe?
    removeEmpty = (obj) => {
        Object.keys(obj).forEach(key => {
            if (obj[key] === undefined || obj[key] === null || obj[key] === '') {
            delete obj[key];
            }
          });
        return obj;
    }
}
